import React from 'react';
import classNames from 'classnames';
import { withSearch } from '@elastic/react-search-ui';
var blockClass = 'no-results';

var NoResults = function NoResults(_ref) {
  var searchTerm = _ref.searchTerm,
      className = _ref.className,
      contentType = _ref.contentType,
      term = _ref.term,
      renderAdditional = _ref.renderAdditional;
  var classes = classNames(blockClass, 'text-center', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("p", {
    className: blockClass + "__message"
  }, "Sorry, we couldn't find any ", contentType.toLowerCase(), " for", ' ', term ? /*#__PURE__*/React.createElement("em", null, term) : searchTerm ? /*#__PURE__*/React.createElement("em", null, searchTerm) : 'your search'), /*#__PURE__*/React.createElement("p", {
    className: "mt-4"
  }, "If you want to continue searching, here are a few tips..."), /*#__PURE__*/React.createElement("p", {
    className: "no-results__tip"
  }, "Remember to check your spelling"), /*#__PURE__*/React.createElement("p", {
    className: "no-results__tip"
  }, "Keep your search term short (one or two words)"), /*#__PURE__*/React.createElement("p", {
    className: "no-results__tip"
  }, "Use more generic terms for a wider set of results"), renderAdditional);
};

export var NoResultsComponent = NoResults;
export default withSearch(function (_ref2) {
  var searchTerm = _ref2.searchTerm;
  return {
    searchTerm: searchTerm
  };
})(NoResults);
NoResults.defaultProps = {
  contentType: 'Results'
};